import { apiClientGeral } from '@/plugins/axios'

export default {
  getFacilidades() {
    return apiClientGeral().get('/facilidades')
  },
  postFacilidades(data) {
    return apiClientGeral().put('/facilidades', data)
  },
}
